import InfographicImg from "public/ztna/Infographic.png";
import { ListWithLabel } from "@/components/list";

export const COLLAB_CONSTANTS = {
  title: "Unified Secure Access — From Edge to Cloud",
  description:
    "OneMind delivers a unified security architecture designed for the hybrid enterprise. Our platform enforces Zero Trust policies, enables real-time threat inspection, and integrates seamlessly with global tech leaders to protect users, data, and infrastructure—anywhere.",
  list: [
    {
      label: "Zero Trust Network Access (ZTNA) ",
      subLabel: "Adaptive & Context-Aware Access Control",
      subText: "Powered by Fortinet & Palo Alto Networks ",
      children: (
        <ListWithLabel
          points={[
            {
              label: "Multi-Factor Authentication (MFA) ",
              text: "Enforces identity-based access with layered authentication for every user and device. ",
            },
            {
              label: "Continuous Risk Analysis",
              text: "Dynamically adapts access based on user behavior & threat signals ",
            },
            {
              label: "Granular Policy Enforcement",
              text: "Secure specific apps, not just entire networks ",
            },
          ]}
        />
      ),
    },
    {
      label: " AI-Driven VPN & Next-Gen Firewall",
      subLabel: "Secure Remote & Hybrid Connectivity",
      subText: "Built with Cisco, Juniper Networks & Fortinet",
      children: (
        <ListWithLabel
          points={[
            {
              label: "Deep Packet Inspection (DPI) & Intrusion Prevention (IPS)",
              text: "Detects & blocks real-time threats",
            },
            {
              label: "AI-Powered Threat Detection",
              text: "Identifies ransomware & phishing before they execute",
            },
            {
              label: "End-to-End Encryption",
              text: "Secures communications across user endpoints & infrastructure",
            },
          ]}
        />
      ),
    },
    {
      label: "Secure Access Service Edge (SASE)",
      subLabel: "Cloud-Native Network Security at Scale",
      subText: "Enabled by  Check Point, and AT&T",
      children: (
        <ListWithLabel
          points={[
            {
              label: "SD-WAN + Cloud Integration",
              text: "Optimizes performance and enforces cloud-native security",
            },
            {
              label: "Unified Security for Remote & On-Prem",
              text: "Consistent policy across all users and apps",
            },
            {
              label: "DDoS Protection & Smart Traffic Filtering",
              text: "Defends against large-scale attacks and data theft",
            },
          ]}
        />
      ),
    },
  ],
  noteText: {
    label: "Unified by OneMind",
    text: "All components are deployed, managed, and monitored through the OneMind platform — providing centralized visibility, automated enforcement, and scalable policy orchestration with no operational silos",
  },
  image: InfographicImg,
  maxW: "600px",
};
